<template>
  <b-modal
    hide-footer
    id="modal-department"
    ref="modal-department"
    size="md"
    title="รายละเอียดหน่วยงาน"
  >
    <div class="container">
      <b-card>
        <b-row>
          <b-col cols="12" class="mb-2">
            <b-form-group label="ชื่อหน่วยงานภาษาไทย">
              <b-form-input
                      id="name"
                      v-model="department.name"
                      readonly
                    />
            </b-form-group>
            
          </b-col>
          <b-col cols="12" class="mb-2">
            <b-form-group label="ApiKey">
              <b-form-input
                      id="departmentId"
                      v-model="department.departmentId"
                      readonly
                    />
            </b-form-group>
            
          </b-col>
          <b-col cols="12" class="mb-2">
            <b-form-group label="รหัสผ่าน">
              <b-form-input
                      id="password"
                      v-model="department.password"
                      readonly
                    />
            </b-form-group>
            
          </b-col>
                    
        </b-row>
        <footer
          id="modal-transfer___BV_modal_footer_"
          class="modal-footer d-flex justify-content-between"
        >
          <button
            type="button"
            class="btn btn-secondary"
            block
          >
            ยกเลิก
          </button>
          <button type="button" class="btn btn-primary" block>
            บันทึก
          </button>
        </footer>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BCard,
} from "bootstrap-vue";

import * as storeMaster from "@/store/api/master/index.js";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BCard,
  },
  props: {
    department: {},
  },
};
</script>

<style></style>
